export const messages = {
  addSignatureButtonLabel: 'Add signature',
  selectUserPlaceholder: 'Select user',
  otherLabel: 'Other',
  optionalLabel: 'Optional',
} as const
